/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_InventoryInputs */

const en_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Inventory`)
};

const es_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar inventario`)
};

const fr_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer l'inventaire`)
};

const de_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventar verwalten`)
};

const ja_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在庫管理`)
};

const zh_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理库存`)
};

const ar_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة المخزون`)
};

const id_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola Inventaris`)
};

const it_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci Inventario`)
};

const ru_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление инвентарем`)
};

const pt_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar Inventário`)
};

const ko_manage_inventory = /** @type {(inputs: Manage_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인벤토리 관리`)
};

/**
* | output |
* | --- |
* | "Manage Inventory" |
*
* @param {Manage_InventoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const manage_inventory = /** @type {((inputs?: Manage_InventoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_InventoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_inventory(inputs)
	if (locale === "es") return es_manage_inventory(inputs)
	if (locale === "fr") return fr_manage_inventory(inputs)
	if (locale === "de") return de_manage_inventory(inputs)
	if (locale === "ja") return ja_manage_inventory(inputs)
	if (locale === "zh") return zh_manage_inventory(inputs)
	if (locale === "ar") return ar_manage_inventory(inputs)
	if (locale === "id") return id_manage_inventory(inputs)
	if (locale === "it") return it_manage_inventory(inputs)
	if (locale === "ru") return ru_manage_inventory(inputs)
	if (locale === "pt") return pt_manage_inventory(inputs)
	return ko_manage_inventory(inputs)
});